import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { AuthService } from '../services/auth.service';
import { AuthResponse } from '../../assets/interfaces/authResponse';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  authResponse: AuthResponse;
  isAuth: boolean;

  curDate: any;
  userName: string;
  password: string;
  newPasswordConfirm: string;
  newPassword: string;
  newPW = false;
  infoBox = '';

  constructor(private appCom: AppComponent, private authService: AuthService) { }

  ngOnInit(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpire');
  }

   postLogin(){
      if (this.isAuth) {
        this.curDate = new Date().getTime();
        this.curDate = new Date().setTime(this.curDate + (12 * 60 * 60 * 1000)); // add 12 hours for expiration

        localStorage.setItem('token', this.authResponse.TOKEN); // get from auth DB
        localStorage.setItem('tokenExpire', new Date(this.curDate).toLocaleString());

        this.appCom.toggleAuth();
      } else {
        this.infoBox = 'Login Failed.';
      }
  }

  updatePW(){
    if (!this.newPW){
      this.newPW = true;
      this.infoBox = 'Please type old password into password box.  Then, type new password into the 2 New Password boxes. Press Update Password button again.';
    }else{
      if (this.newPassword === this.newPasswordConfirm){
        this.infoBox = 'One Minute, please...';
        // auth
      } else {
        this.infoBox = 'Both new password boxes must match.';
      }
    }
  }

  postAuthCall(){
    this.infoBox = 'Authenticating...';

    this.authService.postAuthLogin(this.userName, this.password)
      .subscribe(
        res => {
          this.authResponse = res;
          this.isAuth = res.AUTH;
        },
        error => { console.log('Error:' + error); },
        () => { this.postLogin(); }
      );
  }

}
